var exports = {
  "kL": "x8b4e8595--02cb0d--container",
  "jW": "x8b4e8595--02cb0d--photo",
  "y9": "x8b4e8595--02cb0d--photo-link",
  "B8": "x8b4e8595--02cb0d--content-link",
  "nV": "x8b4e8595--02cb0d--gallery",
  "BI": "x8b4e8595--02cb0d--favorite",
  "q9": "x8b4e8595--02cb0d--price",
  "mZ": "x8b4e8595--02cb0d--price-value",
  "h_": "x8b4e8595--02cb0d--description",
  "hl": "x8b4e8595--02cb0d--address",
  "QY": "x8b4e8595--02cb0d--geo",
  "id": "x8b4e8595--02cb0d--discount",
  "C5": "x8b4e8595--02cb0d--location",
};

module.exports = exports;
